import type { DocumentNode } from 'graphql'

import gql from 'graphql-tag'

const fetchAuthUser: DocumentNode = gql`
  query FetchAuthUser($email: String!) {
    fetchAuthUserByEmail(email: $email) {
      ... on AuthUser {
        uid
        email
      }
      ... on AuthUserNotFound {
        description
        exception
      }
    }
  }
`

export default fetchAuthUser
